export var PROP_DEFAULTS = {
  children: '',
  disabled: false,
  iconPosition: 'left',
  monochrome: false,
  size: 'medium',
  tabIndex: 0,
  variant: 'primary'
};
export var BUTTON_VARIANTS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TEXT: 'text',
  PLAIN: 'plain',
  DELETE: 'delete',
  WEBSITE: 'website'
};
export var BUTTON_SIZE_SPECS = {
  small: {
    font: 'var(--body-text-x-small)',
    horizontal: 'var(--spacing-2)',
    horizontalWithIcon: 'var(--spacing-1)',
    minHeight: 'var(--spacing-4)',
    vertical: '3px'
  },
  medium: {
    font: 'var(--body-text-small)',
    horizontal: 'var(--spacing-3)',
    horizontalWithIcon: 'var(--spacing-2)',
    minHeight: 'var(--spacing-6)',
    vertical: 'var(--spacing-1)'
  },
  large: {
    font: 'var(--body-text-large)',
    horizontal: 'var(--spacing-4)',
    horizontalWithIcon: 'var(--spacing-3)',
    minHeight: 'var(--spacing-8)',
    vertical: '9px'
  }
};
export var BUTTON_COLOR_SPECS = {
  primary: {
    default: {
      background: 'var(--btn-color)',
      boxShadow: 'transparent',
      text: 'var(--btn-text-color)'
    },
    hover: {
      background: 'var(--btn-color-hover)',
      boxShadow: 'transparent',
      text: 'var(--btn-text-color)'
    },
    active: {
      background: 'var(--btn-color-active)',
      boxShadow: 'transparent',
      text: 'var(--btn-text-color)'
    },
    focus: {
      background: 'var(--btn-color-hover)',
      boxShadow: 'var(--btn-color-focus)',
      text: 'var(--btn-text-color)'
    }
  },
  secondary: {
    default: {
      background: 'transparent',
      boxShadow: 'var(--btn-color)',
      text: 'var(--btn-color)'
    },
    hover: {
      background: 'var(--btn-color)',
      boxShadow: 'transparent',
      text: 'var(--btn-text-color)'
    },
    active: {
      background: 'var(--btn-color-active)',
      boxShadow: 'transparent',
      text: 'var(--btn-text-color)'
    },
    focus: {
      background: 'var(--btn-color-focus)',
      boxShadow: 'var(--btn-color-hover)',
      text: 'var(--btn-color-active)'
    }
  },
  text: {
    default: {
      background: 'transparent',
      boxShadow: 'transparent',
      text: 'var(--btn-color)'
    },
    hover: {
      background: 'transparent',
      boxShadow: 'var(--btn-color)',
      text: 'var(--btn-color)'
    },
    active: {
      background: 'transparent',
      boxShadow: 'var(--btn-color-active)',
      text: 'var(--btn-color-active)'
    },
    focus: {
      background: 'var(--btn-color-focus)',
      boxShadow: 'var(--btn-color-hover)',
      text: 'var(--btn-color-active)'
    }
  },
  plain: {
    default: {
      background: 'transparent',
      boxShadow: 'transparent',
      text: 'var(--btn-color)'
    },
    hover: {
      background: 'transparent',
      boxShadow: 'transparent',
      text: 'var(--btn-color-active)'
    },
    active: {
      background: 'transparent',
      boxShadow: 'transparent',
      text: 'var(--btn-color)'
    },
    focus: {
      background: 'transparent',
      boxShadow: 'transparent',
      text: 'var(--btn-color)'
    }
  },
  delete: {
    default: {
      background: 'transparent',
      boxShadow: 'var(--red-core)',
      text: 'var(--text-color)'
    },
    hover: {
      background: 'var(--red-core)',
      boxShadow: 'transparent',
      text: 'var(--white)'
    },
    active: {
      background: 'var(--red-6)',
      boxShadow: 'transparent',
      text: 'var(--white)'
    },
    focus: {
      background: 'var(--red-1)',
      boxShadow: 'var(--red-core)',
      text: 'var(--black)'
    }
  },
  website: {
    default: {
      background: 'var(--website-btn-color)',
      boxShadow: 'transparent',
      text: 'var(--website-btn-text-color)'
    },
    hover: {
      background: 'var(--website-btn-color-hover)',
      boxShadow: 'transparent',
      text: 'var(--website-btn-text-color)'
    },
    active: {
      background: 'var(--website-btn-color-active)',
      boxShadow: 'transparent',
      text: 'var(--website-btn-text-color)'
    },
    focus: {
      background: 'var(--website-btn-color-hover)',
      boxShadow: 'var(--website-btn-color-focus)',
      text: 'var(--website-btn-text-color)'
    }
  }
};